import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_item_travel_allowance_RowClass} from '../../../dbschema';

export class ClaimItemTravelAllowanceContainerModel extends BaseContainerModel {
  bl_aat_claim_item_travel_allowance: bl_aat_claim_item_travel_allowance_RowClass =
    new bl_aat_claim_item_travel_allowance_RowClass();
}
